<ng-container *ngIf="node">
  <aca-tree-view-list
    [node]="node"
    (nodeClicked)="onClick($event)"
    (treeError)="onErrorOccurred($event)"
  >
  </aca-tree-view-list>
</ng-container>
